import script from "./TempE.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempE.vue?vue&type=script&lang=ts&setup=true"

import "./TempE.vue?vue&type=style&index=0&id=d1fc9048&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1fc9048"]])

export default __exports__